export default "__VITE_ASSET__BBj1m6U7__"